(function() {
  const lp2Canvas = document.getElementById("lp2HealthGraph");
  const lp2ScoreDisplayElement = document.getElementById("lp2-score-display");

  if (lp2Canvas && lp2ScoreDisplayElement) {
    const lp2Ctx = lp2Canvas.getContext("2d");
    const lp2Container = lp2Canvas.closest(".lp-2-graph__container");
    const lp2Scores = [35, 48, 40, 61, 55, 79, 93];
    const lp2TodayScore = lp2Scores[lp2Scores.length - 1];
    const config = {
      color: "#FFFFFF",
      glow: "rgba(255, 255, 255, 0.85)",
      pointRadius: 3,
      lineWidth: 1.2,
      curveTension: 0.0,
      speed: 0.007,
      loopDelay: 3000,
    };

    let progress = 0;
    let padding, graphW, graphH, pointDistX, scoreScaleY;

    // Check for disable animation attribute
    // Check for disable animation attribute on the container or any parent
    const disableAnimationWrapper = lp2Canvas.closest("[data-disable-animation]");
    const disableAnimation = disableAnimationWrapper && disableAnimationWrapper.getAttribute("data-disable-animation") === "true";

    function setupLP2() {
      if (!lp2Container) return;
      const dpr = window.devicePixelRatio;
      lp2Canvas.width = lp2Container.clientWidth * dpr;
      lp2Canvas.height = lp2Container.clientHeight * dpr;
      lp2Ctx.setTransform(1, 0, 0, 1, 0, 0);
      lp2Ctx.scale(dpr, dpr);
      padding = { top: 50, right: 20, bottom: 20, left: 20 };
      graphW = lp2Container.clientWidth - padding.left - padding.right;
      graphH = lp2Container.clientHeight - padding.top - padding.bottom;
      pointDistX = lp2Scores.length > 1 ? graphW / (lp2Scores.length - 1) : graphW;
      scoreScaleY = graphH / 100;

      // If static or progress started, draw
      if (disableAnimation || progress > 0) drawLP2();
    }

    function drawLP2() {
      const dpr = window.devicePixelRatio;
      lp2Ctx.clearRect(0, 0, lp2Canvas.width / dpr, lp2Canvas.height / dpr);
      const segments = progress * (lp2Scores.length - 1);

      const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
      const lineWidth = window.innerWidth <= 767 ? (0.1 * rootFontSize) / dpr : config.lineWidth;

      lp2Ctx.beginPath();
      lp2Ctx.lineWidth = lineWidth * dpr;
      lp2Ctx.strokeStyle = config.color;
      lp2Ctx.lineCap = "round";
      lp2Ctx.lineJoin = "round";
      lp2Ctx.shadowBlur = 15 * dpr;
      lp2Ctx.shadowColor = config.glow;

      const startX = padding.left;
      const startY = padding.top + graphH - lp2Scores[0] * scoreScaleY;
      lp2Ctx.moveTo(startX, startY);

      for (let i = 0; i < lp2Scores.length - 1; i++) {
        const segProgress = segments - i;
        if (segProgress <= 0) break;
        const x1 = padding.left + i * pointDistX;
        const y1 = padding.top + graphH - lp2Scores[i] * scoreScaleY;
        const x2 = padding.left + (i + 1) * pointDistX;
        const y2 = padding.top + graphH - lp2Scores[i + 1] * scoreScaleY;

        if (segProgress >= 1) {
          const cpX = x1 + (x2 - x1) * config.curveTension;
          const cpY = y1 + (y2 - y1) * config.curveTension;
          lp2Ctx.quadraticCurveTo(cpX, cpY, x2, y2);
        } else {
          const px = x1 + pointDistX * segProgress;
          const py = y1 + (y2 - y1) * segProgress;
          const cpX = x1 + (px - x1) * config.curveTension;
          const cpY = y1 + (py - y1) * config.curveTension;
          lp2Ctx.quadraticCurveTo(cpX, cpY, px, py);
        }
      }
      lp2Ctx.stroke();
      lp2Ctx.shadowBlur = 0;

      lp2Ctx.fillStyle = config.color;
      lp2Ctx.shadowBlur = 10 * dpr;
      lp2Ctx.shadowColor = config.glow;

      const pointRadius = window.innerWidth <= 767 ? (0.251 * rootFontSize) / dpr : config.pointRadius;

      for (let i = 0; i < lp2Scores.length; i++) {
        if (i <= segments || (i === 0 && segments >= 0) || progress >= 1) {
          const x = padding.left + i * pointDistX;
          const y = padding.top + graphH - lp2Scores[i] * scoreScaleY;
          lp2Ctx.beginPath();
          lp2Ctx.arc(x, y, pointRadius * dpr, 0, Math.PI * 2);
          lp2Ctx.fill();
        }
      }
      lp2Ctx.shadowBlur = 0;

      if (progress >= 1) {
        lp2ScoreDisplayElement.innerHTML = `${lp2TodayScore}<span class="lp2-score-pt">pt</span>`;
        lp2ScoreDisplayElement.style.opacity = "1";
        lp2ScoreDisplayElement.style.transform = "translateY(0) scale(1)";
      }
    }

    function animateLP2() {
      drawLP2();
      if (progress < 1) {
        progress += config.speed;
        if (progress > 1) progress = 1;
        requestAnimationFrame(animateLP2);
      }
    }

    if (disableAnimation) {
        progress = 1;
        setupLP2(); // will draw because progress=1
        window.addEventListener('resize', setupLP2);
    } else {
        setupLP2();
        window.addEventListener('resize', setupLP2);
        requestAnimationFrame(animateLP2);
    }
  }
})();
